import React from "react";
import { useStateValue } from "./StateProvider";
import Player from "./Player";
import "./SummaryMoney.css";
import firebase from "firebase";

function SummaryMoney() {
  const [{ user }] = useStateValue();
  const [{ players }] = useStateValue();
  const [{ skins }] = useStateValue();
  const [{ dogmeat }] = useStateValue();
  const [{ lowfront }] = useStateValue();
  const [{ lowback }] = useStateValue();
  const [{frontteam}] = useStateValue();
  const [{backteam}] = useStateValue();

  const getPlayerSkins = (id) => {
    const skinHoles = skins.filter((s) => s.Winner === id);
    const dmHoles = dogmeat.filter((s) => s.id === id);
    const Total = skinHoles?.reduce(
      (totalStrokes, score) => totalStrokes + score.Amount,
      0
    );
    return Total + dmHoles.length;
  };

  const getTotalSkins = () => {
    const Total = skins?.reduce(
      (totalSkins, score) => totalSkins + score.Amount,
      0
    );
    return Total + dogmeat.length;
  };

  const getF9Winner = (id) => {
    var winnings = 0;
    // console.log("saved",lowfront[0])
    if (lowfront[0] === id) {
      winnings = 5 * (players.length - 1);
    } else {
      winnings = -5;
    }
    if ((lowfront[0] === "") | (lowfront[0] === undefined)) {
      winnings = 0;
    }
    return winnings;
  };
  const getB9Winner = (id) => {
    var winnings = 0;
    //console.log("saved",lowback[0])
    if (lowback[0] === id) {
      winnings = 5 * (players.length - 1);
    } else {
      winnings = -5;
    }
    // console.log("lowback",lowback[0])
    if ((lowback[0] === "") | (lowback[0] === undefined)) {
      winnings = 0;
    }
    return winnings;
  };

  const getFT9Winner = (id) => {
    var winnings = 0;
    const player = players.filter((s) => s.id === id);
    // console.log("ftW",frontteam)
    // console.log("pt", (player[0].team) )
    if (player[0].team == frontteam) {
      winnings = 5;
    } else {
      winnings = -5;
    }
    if ((frontteam === "") | (frontteam === undefined)) {
      winnings = 0;
    }
    return winnings;
  }; 

  const getBT9Winner = (id) => {
    var winnings = 0;
    const player = players.filter((s) => s.id === id);
    // console.log("ftW",backteam)
    // console.log("pt", (player[0].team) )
    if (player[0].team == backteam) {
      winnings = 5;
    } else {
      winnings = -5;
    }
    if ((backteam === "") | (backteam === undefined)) {
      winnings = 0;
    }
    return winnings;
  }; 

  //************************************************************************************************************************* */
const skinAmount =(id) => (players.find((p)=>p.id===id)).skinWager
const playersInSkins=()=>players.filter((p)=> p.inGroupSkins)
const playersInLow9=()=>players.filter((p)=> p.inLow9)
const playersInTeam9=()=>players.filter((p)=> p.inTeam9)

// const team9amout=()=>(players.find((p)=>p.id===id)).skinWager
// console.log("Skin Wager", skinAmount(id))
// console.log("In Skin", playersInSkins())
// console.log("In Low 9", playersInLow9())

  const calcTotals = (id) => {
    const skins =(players.find((p)=>p.id===id)).inGroupSkins ? getPlayerSkins(id) * skinAmount(id) * playersInSkins().length - getTotalSkins() * skinAmount(id):0;
    const f9 =  (players.find((p)=>p.id===id)).inLow9 ? parseFloat(getF9Winner(id)):0;
    const b9 =  (players.find((p)=>p.id===id)).inLow9 ? parseFloat(getB9Winner(id)):0;
    const ft9 =  (players.find((p)=>p.id===id)).inTeam9 ? parseFloat(getFT9Winner(id)):0;
    const bt9 =  (players.find((p)=>p.id===id)).inTeam9 ? parseFloat(getBT9Winner(id)):0;
    return parseFloat(skins) + parseFloat(f9) + parseFloat(b9) + parseFloat(ft9)+ parseFloat(bt9)     ;
  };


  const Test = () => {
    const d = new Date();

    var payoutInfo = players.map(function (player) {
      var payout = {
        [player.first]: calcTotals(player.id),
      };
      // return JSON.stringify(payout);
      return payout;
    });
 

 

    // console.log("payoutInfo", payoutInfo);
    // console.log("user", user);
    //console.log("Payout", payout);

    //**save to firebas */
    firebase
      .firestore()
      .collection("winnings")
      .doc(
        d.getFullYear() +
          "-" +
          parseInt(d.getMonth() + 1) +
          "-" +
          d.getDate() +
          " " +
          d.getTime()
      )
      .set({
        uid:user.uid,
        scorer: user.displayName,
        payoutInfo,
      })
      .then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };

  return (
    <div>
      <div>
        <h2 className="subTitle">Payouts</h2>
      </div>

      <div className="money">
        <table className="money__table">
          <thead>
            <tr>
              <th>Name</th>
              <th>#Skins</th>
              <th>$Skins</th>
              {(players.filter((p)=>p.inLow9===true)).length>0 &&
              <>
              <th>$F9</th>
              <th>$B9</th>
              </>
              }
            {(players.filter((p)=>p.inTeam9===true)).length>0 &&
              <>
              <th>$TF9</th>
              <th>$TB9</th>
              </>
              }
              <th>$TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {players.map((player) => (
              <tr key={player.id}>
                {/* <div className="playerstats"> */}
                <td className="player__name">
                  <Player id={player.id} />
                </td>

                <td className="playerSkins"> {(players.find((p)=>p.id===player.id)).inGroupSkins ? getPlayerSkins(player.id) : "" }</td>
                <td className="playerSkinsW"> 
                {(players.find((p)=>p.id===player.id)).inGroupSkins ? 
                  (
                    getPlayerSkins(player.id) * skinAmount(player.id) * playersInSkins().length -
                    getTotalSkins() * skinAmount(player.id)
                  ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })  :""}
                </td>
                {(players.filter((p)=>p.inLow9===true)).length>0 &&
                <>
                <td className="f9">
                  {(players.find((p)=>p.id===player.id)).inLow9 ?
                  getF9Winner(player.id).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  }) :""}
                </td>
              
                <td className="b9">
                {(players.find((p)=>p.id===player.id)).inLow9?
                  getB9Winner(player.id).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  }) :""}
                </td>
                </>
                }

                {(players.filter((p)=>p.inTeam9===true)).length>0 &&
                <>
                <td className="f9team">
                {(players.find((p)=>p.id===player.id)).inTeam9 ?
                  getFT9Winner(player.id).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  }) :""}
                </td>

              
                <td className="f9team">
                {(players.find((p)=>p.id===player.id)).inTeam9 ?
                  getBT9Winner(player.id).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  }) :""}
                </td>
                </>
                }
              
                <td className="f__totals">
                  {calcTotals(player.id).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
                </td>
                {/* </div> */}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="save">
          <button className="save__button" onClick={Test}>
            Save Payouts
          </button>
        </div>
      </div>
    </div>
  );
}

export default SummaryMoney;
